const weekApi = {
  UPDATEWEEK: 'CSVPA-China/api/weeks/update', //编辑教学周
  GETWEEKLISTBYCLASSID: 'CSVPA-China/api/weeks/getListByClassId', //教学周
  GETADVISORWEEK: 'CSVPA-China/api/feedbackWeeks/getListByClassId', //班主任教学周
  EDITADVISORWEEK: 'CSVPA-China/api/feedbackWeeks/edit', //编辑班主任教学周
  addWeek: 'CSVPA-China/api/weeks/addWeek', //添加周
  // updateWeek: 'CSVPA-China/api/weeks/update', //添加周
  deleteWeek: 'CSVPA-China/api/weeks/delete', //删除某个周
  getWeekList: 'CSVPA-China/api/weeks/getWeekPage', //获取全部周
  getWeekListAll: 'CSVPA-China/api/weeks/getBasicGradeWeeks',
  GETALLWEEKS: 'CSVPA-China/api/weeks/getListAll'
}

export default weekApi
